/* Layout */
import Layout from '@/views/layout/Layout'

/** note: submenu only apppear when children.length>=1
*   detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
**/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true, meta: {type: 'login'} },
  { path: '/register', component: () => import('@/views/login/register'), hidden: true, meta: {type: 'register'} },
  { path: '/forgetpsw', component: () => import('@/views/login/forgetpsw'), hidden: true },
  { path: '/authredirect', component: () => import('@/views/login/authredirect'), hidden: true },
  { path: '/thirdpartyloginredirect', component: () => import('@/views/login/third-party-login/LoginRedirect'), hidden: true },

  { path: '/404', component: () => import('@/views/errorPage/404'), hidden: true },
  { path: '/401', component: () => import('@/views/errorPage/401'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    meta: {
      title: 'dashboard',
      icon: 'iconfont icon-shouye'
    },
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      name: 'dashboard',
      meta: {
        title: 'dashboard'
      }
    }]
  }
]

export default new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  // 修改密码
  {
    path: '/myresetPassword',
    component: Layout,
    redirect: '/myresetPassword/index',
    name: 'my-resetPassword',
    meta: {
      title: 'resetPassword'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/my/ResetPassword'),
        name: 'my-resetPassword-index',
        meta: {
          title: 'resetPassword',
          noCache: true
        }
      }
    ]
  },
  // 合作渠道管理
  {
    path: '/channelmanage',
    component: Layout,
    redirect: '/channelmanage/',
    meta: {
      // roles: ['ROLE_SYSTEMMANAGER', 'ROLE_CHANNEL_ADMIN', 'ROLE_CHANNEL_ONE'],
      title: 'channelManage',
      icon: 'iconfont icon-yonghuguanli1'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/channel-manage/Index'),
        name: 'channelManage',
        meta: {
          // roles: ['ROLE_SYSTEMMANAGER', 'ROLE_CHANNEL_ADMIN', 'ROLE_CHANNEL_ONE'],
          title: 'channelManage'
        }
      }
    ]
  },
  // 报名信息
  {
    path: '/enrollInfo',
    component: Layout,
    redirect: '/enrollInfo/',
    meta: {
      // roles: ['ROLE_SYSTEMMANAGER', 'ROLE_CHANNEL_ADMIN', 'ROLE_CHANNEL_ONE'],
      title: 'enrollInfo',
      icon: 'iconfont icon-yonghuguanli1'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/enroll-info/Index'),
        name: 'enrollInfo',
        meta: {
          // roles: ['ROLE_SYSTEMMANAGER', 'ROLE_CHANNEL_ADMIN', 'ROLE_CHANNEL_ONE'],
          title: 'enrollInfo'
        }
      }
    ]
  },
  // 小程序支付订单
  {
    path: '/paymentOrder',
    component: Layout,
    redirect: '/paymentOrder/',
    meta: {
      title: 'paymentOrder',
      icon: 'iconfont icon-yonghuguanli1'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/paymentOrder/Index'),
        name: 'paymentOrder',
        meta: {
          title: 'paymentOrder'
        }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js